import {
  createFeatureSelector,
  createReducer,
  createSelector,
  on,
} from "@ngrx/store";
import { ConsultantSearchIndustryApiActions } from "@skills-app/industry/actions";
import { IIndustryItem } from "@skills-app/models/industry";

export interface IIndustryState {
  industryItems: IIndustryItem[];
}

const initialState: IIndustryState = {
  industryItems: [],
};

export const reducer = createReducer(
  initialState,
  on(
    ConsultantSearchIndustryApiActions.populateIndustryItems,
    (state, action) => ({
      ...state,
      industryItems: action.items,
    }),
  ),
  on(ConsultantSearchIndustryApiActions.unloadComponent, (state) => ({
    ...state,
    industryItems: [],
  })),
);

export const getIndustryState =
  createFeatureSelector<IIndustryState>("industry");

export const getIndustryItems = createSelector(
  getIndustryState,
  (s) => s.industryItems,
);
